export default {"src":"/_next/static/media/heart-footer.ba9a1fc1.svg","height":54,"width":60};